import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaParecerComissaoRecursoRecebidoInicio: [],
    buscaParecerComissaoRecursoRecebidoSucesso: ['parecerComissaoRecursoRecebido'],
    buscaParecerComissaoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaParecerComissaoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaParecerComissaoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarParecerComissao(filtro)
            .then(response => dispatch(Creators.buscaParecerComissaoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaParecerComissaoRecursoRecebidoErro(error)))
    }
}

const buscaParecerComissaoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaParecerComissaoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaParecerComissaoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.parecerComissaoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_RECEBIDO_INICIO]: buscaParecerComissaoRecursoRecebidoInicio,
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_RECEBIDO_ERRO]: buscaParecerComissaoRecursoRecebidoErro,
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_RECEBIDO_SUCESSO]: buscaParecerComissaoRecursoRecebidoSucesso,
})
